import { Grid } from "@mui/material";
import { ArrayInput, FormDataConsumer, ReferenceInput, required, SelectInput, SimpleFormIterator } from "react-admin";
import { settings } from "app";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { CourseChoices, FromWeekToWeekChoices, WeekDaysChoices, WeekTypeChoices } from "utils/choices";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import { validateFromToWeek, validateTimeStart } from "../CreateWeeklySchedule/utils/utils";
import AcademicSessionIdFilterBlock from "./components/AcademicSessionIdFilterBlock";
import RoomInput from "server/components/Fields/RoomInput";
import { activityRequests } from "api/activityApi";

const CreateSaveForm = ({ hasSavedFilters }) => {
  return (
    <>
      <AcademicSessionIdFilterBlock hasSavedFilters={hasSavedFilters} />
      <Grid
        container
        spacing={2}
      >
        <ArrayInput
          source="activities"
          label="Разписания"
          sx={{ ml: 2, mt: 2 }}
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            disableReordering
            disableClear
            sx={settings.style.iteratorWithoutGap}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={8}
              >
                <ProfessorInput
                  source="professorEmployeeId"
                  fullWidth
                  filters={{ hasForeignLanguage: true }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
              >
                <SelectInput
                  source="course"
                  label="Курс"
                  choices={CourseChoices}
                  optionValue="id"
                  optionText="name"
                  alwaysOn
                  emptyText={false}
                />
              </Grid>
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <SelectInput
                        label="От седмица"
                        source="fromWeek"
                        choices={FromWeekToWeekChoices}
                        validate={[required(), () => validateFromToWeek(scopedFormData)]}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <SelectInput
                        label="До седмица"
                        source="toWeek"
                        choices={FromWeekToWeekChoices}
                        validate={[required(), () => validateFromToWeek(scopedFormData)]}
                      />
                    </Grid>
                  </>
                )}
              </FormDataConsumer>
              <Grid
                item
                xs={12}
                md={3}
              >
                <SelectInput
                  label="Тип седмица"
                  source="weekType"
                  choices={WeekTypeChoices}
                  validate={required()}
                  defaultValue={1}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
              >
                <SelectInput
                  source="weekDay"
                  label="Ден от седмицата"
                  choices={WeekDaysChoices}
                  optionValue="id"
                  optionText="name"
                  validate={[required()]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
              >
                <RoomInput
                  source="roomId"
                  label="Зала"
                />
              </Grid>
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <CustomTimeOnlyInput
                        source="startTime"
                        label="Започва в (час)"
                        validate={() => validateTimeStart(scopedFormData)}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <CustomTimeOnlyInput
                        source="endTime"
                        label="Приключва в (час)"
                        validate={() => validateTimeStart(scopedFormData)}
                      />
                    </Grid>
                  </>
                )}
              </FormDataConsumer>
              <Grid
                container
                spacing={2}
                sx={{ ml: 0, mt: 3 }}
              >
                <Grid
                  item
                  xs={12}
                  md={4}
                >
                  <ReferenceInput
                    reference={activityRequests.getActivityForeignLanguagesSelect()}
                    source="foreignLanguageId"
                  >
                    <SelectInput
                      label="Избор на чужд език"
                      optionText="name"
                      validate={[required()]}
                    />
                  </ReferenceInput>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                >
                  <FormDataConsumer>
                    {({ scopedFormData }) =>
                      scopedFormData?.foreignLanguageId && (
                        <ReferenceInput
                          key={scopedFormData?.foreignLanguageId}
                          reference={`activity/foreign-languages/${scopedFormData?.foreignLanguageId}/levels/select`}
                          source="foreignLanguageLevel"
                        >
                          <SelectInput
                            label="Ниво на чужд език"
                            optionText="name"
                            validate={[required()]}
                          />
                        </ReferenceInput>
                      )
                    }
                  </FormDataConsumer>
                </Grid>
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </>
  );
};

export default CreateSaveForm;
